// Types
import {
  CrusherOperationalData,
  TrendingType,
} from '../../../../../types/crusher';
import {
  EdgeDeviceOperationalStatus,
  EdgeDeviceOperationalStatusStatus,
} from '../../../../../types/global';

export interface TrendingsProps {
  alternativeTrending?: TrendingType;
  className?: string;
  idEquipmentUnit: string;
  onCloseTrendings: () => void;
  operationalData: CrusherOperationalData;
  showTrendings: boolean;
  testId?: string;
}

export enum TrendingStatistic {
  max = 'max',
  avg = 'avg',
  min = 'min',
}

export enum ChartMode {
  history = 'history',
  live = 'live',
  liveAggregate = 'live-aggregate',
}

export interface TrendingsChartData {
  timestamp: number;
  edgeStatus: number;
  crusherMotor1Amps: number | null;
  crusherMotor2Amps: number | null;
  crusherMotorRPM: number | null;
  lubricationSupplyTemperature: number | null;
  lubricationReturnTemperature: number | null;
  lubricationTankTemperature: number | null;
  vibrationSensor1: number | null;
}

export type AggregateValue = { max?: number; avg?: number; min?: number };
export type SensorChartData = Omit<TrendingsChartData, 'edgeStatus'>;
export type CondensedHistoryItem = {
  timestamp: number;
  edgeStatus?: EdgeDeviceOperationalStatusStatus | number | null;
} & Record<string, number | AggregateValue | null>;
export type ChartItemTab = {
  key: TrendingType;
  label: string;
};

export type TrendingRawItem = (
  EdgeDeviceOperationalStatus | CondensedHistoryItem
);

export type EdgeLike = { edgeStatus?: EdgeDeviceOperationalStatusStatus | number | null };

export interface ProcessedTrendingData {
  timestamp: number;
  edgeStatus?: EdgeDeviceOperationalStatusStatus | number | null;
  crusherMotor1Amps?: number | AggregateValue | null;
  crusherMotor2Amps?: number | AggregateValue | null;
  crusherMotorRPM?: number | AggregateValue | null;
  lubricationSupplyTemperature?: number | AggregateValue | null;
  lubricationReturnTemperature?: number | AggregateValue | null;
  lubricationTankTemperature?: number | AggregateValue | null;
  vibrationSensor1?: number | AggregateValue | null;
}
